const validateLung=(formData)=>//check NG12 criteria

{
let message0= "NICE recommends:-" 

let message1 = "Refer people using a suspected cancer pathway referral for lung cancer if they have chest X‑ray findings that suggest lung cancer or are aged 40 and over with unexplained haemoptysis."

let message2 = "Offer an urgent chest X‑ray (to be done within 2 weeks) to assess for lung cancer in people aged 40 and over if they have 2 or more of the following unexplained symptoms, or if they have ever smoked and have 1 or more of the following unexplained symptoms: cough, fatigue, shortness of breath, chest pain, weight loss, appetite loss."

let message3= "Consider an urgent chest X‑ray (to be done within 2 weeks) to assess for lung cancer in people aged 40 and over with any of the following: persistent or recurrent chest infection,finger clubbing,supraclavicular lymphadenopathy or persistent cervical lymphadenopathy, chest signs consistent with lung cancer, thrombocytosis."


if (formData.cxrLung)
    {
    formData.twrValid.lung=true
    formData.message.lung=message0 + message1
    return formData
    }

if (formData.age<40)
    {
     return formData   
    }

if (formData.haemoptysis)
    {
    formData.twrValid.lung=true
    formData.message.lung=message0 + message1
    return formData
    }

if (formData.cxrPleural)// patient has already had a CXR- will be validated under pleural path
    {
    return formData
    }

const XrSymptoms=["cough", "fatigue", "sob", "chestPain", "weightLoss", "appetiteLoss" ]
let xrSymptomCount=0

formData.symptomList.forEach(symptom=>
  {if (XrSymptoms.includes(symptom))
        {
        xrSymptomCount+=1  
        }
    })

if (xrSymptomCount>=2 || (xrSymptomCount > 0 && formData.smoker))
    {
        formData.message.lung = message0 + message2
        formData.investigations.push("Chest X Ray")  
        return formData  
    }


if (formData.chestInfection || 
    formData.fingerClubbing||
    formData.neckNodes ||
    formData.chestSignsLung ||
    formData.thrombocytosis
    )
        {
        formData.message.lung = message0 +message3
        formData.investigations.push("Chest X Ray") 
        }
 return formData

}

export default validateLung
